import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { IAnyExternalLinks, IExternalLinks } from '../../models/IExternalLinks';
import { MediaType } from '../../models/media-type.enum';
import { ProductMedia } from '../../models/product-media.model';

export class UtilService
{
    public static getHttpParamsFromObject(object: any): HttpParams
    {
        let params = new HttpParams();
        for (const key of Object.keys(object))
        {
            if (object[key])
            {
                params = params.set(key, object[key]);
            }
        }
        return params;
    }

    public static goToUrl(url: string, externalLinks: IExternalLinks, router: Router): void {
        const levels: string[] = url?.split('/');
        let source: IAnyExternalLinks = externalLinks;
        for (let i = 0; i < levels.length; i++){
            source = source[levels[i]];
        }
        if (typeof source === 'string'){
            if(source[0] === '/'){
                router.navigate([source]);
            } else {
                window.open(source);
            }
        }
    }

    public static checkConfiguration(url: string, externalLinks: IExternalLinks): boolean {
        if(!externalLinks) {
            return false;
        }
        const levels: string[] = url?.split('/');
        let source: IAnyExternalLinks = externalLinks;
        for (let i = 0; i < levels.length; i++){
            source = source[levels[i]];
        }
        if (typeof source === 'string'){
            return true;
        } else {
            return false;
        }
    }

    /**
     * Returns the image that will be displayed on the product card.
     * @param medias the product media array where the main image will be found.
     * @returns A string containing the url of the image.
     */
    public static getExhibitionMediaData(medias: Array<ProductMedia>): string {
        const image: string = this.getMainProductImage(medias);
        if (image) {
            return image;
        } else {
            return this.getVideoImage(medias);
        }
    }

    /**
     * Returns the main image of the product.
     * @param medias the product media array where the main image will be found.
     * @returns A string containing the url of the image.
     */
    private static getMainProductImage(medias: Array<ProductMedia>): string {
        const image: ProductMedia = medias?.find(item => item?.type === MediaType.IMAGE && item?.midia_url !== undefined && item?.order === 0);
        if (image) {
            return image?.midia_url;
        }
    }

    /**
     * Returns the product video image.
     * @param medias the product media array where the main image will be found.
     * @returns A string containing the url of the image.
     */
    private static getVideoImage(medias: Array<ProductMedia>): string {
        const video: ProductMedia = medias?.find(item => item?.type === MediaType.VIDEO && item?.midia_url !== undefined);
        if(video) {
            var output = video.midia_url.substr(video.midia_url.indexOf("=") + 1);

            return `http://img.youtube.com/vi/${output}/default.jpg`
        }
        return undefined;
    }
}
